namespace JupitersChoice {
    export class SetRestoreStateCmd {

        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameConfig') _gameConfig: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('UserModel') _userModel: Sapphire.UserModel;

        private _restoreState: string;
        private _setRestoreStateAttempts: number = 0;

        execute(): void {
            this._userModel.incrementRestoreVersion();

            if (this._stateModel.currentSubgame === 'BaseGame') {
                this._restoreState = JSON.stringify({
                    basegame: true
                });
            } else if (this._stateModel.currentSubgame === 'FreeGame') {
                if (!ShowFreeGameCmd.currentFreeGameSpinIdx) {
                    ShowFreeGameCmd.currentFreeGameSpinIdx = 1;
                }

                this._restoreState = JSON.stringify({
                    fsNumber: ShowFreeGameCmd.currentFreeGameSpinIdx
                });
            }

            this.makeSetRestoreStateCall();
        }

        makeSetRestoreStateCall(): void {
            this._gameServer.setRestoreState(this._userModel.sessionId, this._gameConfig.get('game', 'gameName'), this._restoreState, this._userModel.restoreVersion, () => {
                //this._eventManager.publish('onConnectionError');
                this._setRestoreStateAttempts++;

                if (this._setRestoreStateAttempts < 2) {
                    this.makeSetRestoreStateCall();
                } else {
                    console.log('Could not set restore point for this spin');
                }
            });
        }
    }
}